import { getScaleToWindow } from './getScaleToWindow';
export var getScaleToWindowMax = function (width, naturalWidth, height, naturalHeight, offset) {
    var scale = getScaleToWindow(naturalWidth, naturalHeight, offset);
    var ratio = naturalWidth > naturalHeight ? naturalWidth / width : naturalHeight / height;
    return scale > 1 ? ratio : scale * ratio;
};
